import { useEffect, useState } from 'react';
export function useListLoading({ queryLoading, data, error, ready = true, }) {
    const [gridLoading, setGridLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (queryLoading)
            return;
        if (!ready)
            return;
        if (!data && !error)
            return;
        setGridLoading(false);
        setIsLoading(false);
    }, [queryLoading, data, error, ready]);
    return { gridLoading, isLoading, setIsLoading };
}
//# sourceMappingURL=use-list-loading.js.map